import * as React from 'react';
import { cn } from '../../lib/utils';

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
        <div
            ref={ref}
            className={cn(
                'rounded-[16px] bg-card text-card-foreground border border-border shadow-elevated transition-shadow hover:shadow-[0_6px_22px_rgba(0,0,0,0.088)] overflow-hidden',
                className
            )}
            {...props}
        />
    )
);
Card.displayName = 'Card';

export { Card };



